import type { SelectedAlert } from '~/@types/redux';
import {
  RuleReferenceTypes,
  RuleResultStatuses,
} from '~/common/constants/api-ids';
import { getKeyByValue } from '~/common/util/object';

/** DOM state shared by every alert in the left drawer, so UI automation can read it the same way for parents and children. */
export function alertStateAttributes(
  alert: Pick<
    SelectedAlert,
    'gutterItemId' | 'ruleReferenceTypeId' | 'ruleReferenceId'
  >,
  selectedAlert: Pick<SelectedAlert, 'gutterItemId'> | null,
  statusId: number,
) {
  return {
    'aria-current':
      alert.gutterItemId === selectedAlert?.gutterItemId ? 'page' : undefined,
    'data-alert-status': getKeyByValue(RuleResultStatuses, statusId),
    'data-document-id':
      alert.ruleReferenceTypeId === RuleReferenceTypes.document
        ? alert.ruleReferenceId
        : undefined,
  } as const;
}
